<template>
  <div class="login-main">
    <nav-bar></nav-bar>
    <section class="gift-start">
      <div class="review-container review-main text-capitalize position-relative container">
        <div class="row">
          <div class="col-md-12">
            <div class="chowman-pay-details plr15 d-flex justify-space-between">
              <h4 class="text-left">Gift Voucher</h4>
              <div class="full-btn">
                <router-link :to="{ name: 'gift-voucher-history' }" class="back-btn btn">History</router-link>
              </div>
            </div>
            <div class="gift-full-img pt-3" v-if="Object.keys(selectGift).length > 0">
              <img :src="selectGift.full_image" />
            </div>
            <div class="centered">{{ selectGift.title }}</div>
            <div class="myhome-slider" v-if="voucherList && voucherList.length > 0">
              <div id="testimonial-slider" class="owlcarousel">
                <div v-bind="settings" class="giftslide">
                  <div v-for="(voucher, index) in voucherList" :key="index" class="vue-slide-carousel gift-nw-side">
                    <a href="javascript:void(0)" @click="selectVoucher(voucher)">

                      <div class="gift-card-image-wrapper">
                        <div class="testimonial-item equal-height style-6" :class="selectGift.id == voucher.id ? 'activeSlide' : ''
                          ">
                          <img :src="voucher.full_image" />
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="gift_amount mt-4">
              <h4>Amount</h4>
              <div class="gamnt">
                <div class="pay-chowmn" :class="{ 'is-invalid': $v.profile.amount.$error }">
                  <span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>
                  <input class="form-control mb-0 h50" type="number" onKeyPress="if(this.value.length==8) return false;"
                    placeholder="0.0" id="amount" name="amount" v-model="$v.profile.amount.$model" autofocus
                    style="resize: horizontal; width: 200px" />
                </div>
                <div v-if="$v.profile.amount.$error" class="invalid-feedback">
                  <span v-if="!$v.profile.amount.required">{{
                    $t("Please enter amount")
                    }}</span>
                  <span v-else-if="!$v.profile.amount.between">Please enter minimum amount
                    <span v-html="$auth.setting && $auth.setting.currency" class="currency"></span>{{
                      $auth.setting.minimum_voucher_amount }}</span>
                </div>
              </div>
            </div>

            <div class="gift_delivery mt-4 orders-tab-main">
              <div class="gift-deli">
                <div class="delivery-pay-chowmn">
                  <div class="tab-content">
                    <div id="email" class="tab-pane active tab-box">
                      <div class="mt-4">
                        <div class="mt-4 position-relative">
                          <h6 class="mb-2">{{ $t("To") }}</h6>
                          <input class="form-control mb-0 h50" type="text" :placeholder="$t('Name')" aria-label="Name"
                            v-model="$v.profile.toname.$model" :class="{ 'is-invalid': $v.profile.toname.$error }" />
                          <div v-if="$v.profile.toname.$error" class="invalid-feedback">
                            <span v-if="!$v.profile.toname.required">{{
                              $t("Please enter name")
                              }}</span>
                          </div>
                        </div>
                        <div class="mt-4 position-relative">
                          <h6 class="mb-2">{{ $t("Recipient Email") }}</h6>
                          <input class="form-control mb-0 h50" type="text" :placeholder="$t('Email')" aria-label="Email"
                            v-model="$v.profile.toemail.$model" :class="{ 'is-invalid': $v.profile.toemail.$error }" />
                          <div v-if="$v.profile.toemail.$error" class="invalid-feedback">
                            <span v-if="!$v.profile.toemail.required">{{
                              $t("Please enter email")
                              }}</span>
                            <span v-if="!$v.profile.toemail.email">{{
                              $t("This value should be a valid email")
                              }}</span>
                          </div>
                        </div>
                        <div class="mt-4 position-relative">
                          <h6 class="mb-2">{{ $t("From") }}</h6>
                          <input class="form-control mb-0 h50" type="text" :placeholder="$t('From name')"
                            aria-label="Name" v-model="$v.profile.fromname.$model" :class="{
                              'is-invalid': $v.profile.fromname.$error,
                            }" />
                          <div v-if="$v.profile.fromname.$error" class="invalid-feedback">
                            <span v-if="!$v.profile.fromname.required">{{
                              $t("Please enter name")
                              }}</span>
                          </div>
                        </div>
                        <div class="mt-4 position-relative">
                          <h6 class="mb-2">{{ $t("Your Message") }}</h6>
                          <textarea name="message" class="form-control mb-0 h50" v-model="$v.profile.message.$model"
                            :class="{ 'is-invalid': $v.profile.message.$error }"></textarea>
                          <div v-if="$v.profile.message.$error" class="invalid-feedback">
                            <span v-if="!$v.profile.message.required">{{
                              $t("Please enter message")
                              }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="delivery-address border-0 mt-4">
                        <div class="full-btn" id="send">
                          <button @click="send()" class="red-outline-btn send-cls">
                            {{ $t("Send Voucher") }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer></Footer>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import LottieAnimation from "lottie-web-vue";
import NavBar from "@/components/NavBar.vue";
import Footer from "../components/Footer.vue";
import VueSkeletonLoader from "skeleton-loader-vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { required, email, between } from "vuelidate/lib/validators";

export default {
  components: {
    NavBar,
    Footer,
    "skeleton-loader-vue": VueSkeletonLoader,
    LottieAnimation,
    VueSlickCarousel,
  },
  data() {
    return {
      voucherList: [],
      selectGift: {},
      profile: {
        toemail: "",
        fromname: "",
        toname: "",
        message: "",
        amount: "",
      },
      minimumAmount: 1,
      settings: {
        focusOnSelect: false,
        touchThreshold: 5,
        dots: true,
        arrows: false,
        infinite: true,
        speed: 1200,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 3.5,
              dots: false,
              arrows: false,
            },
          },
        ],
      },
    };
  },

  // validations: {
  //   profile: {
  //     toemail: {
  //       required,
  //       email,
  //     },
  //     fromname: {
  //       required,
  //     },
  //     amount:{
  //       required,
  //       between: between(1,this.minimumAmount)
  //     }
  //   },
  // },

  validations() {
    if (this.minimumAmount > 0) {
      return {
        profile: {
          toemail: {
            required,
            email,
          },
          toname: {
            required,
          },
          fromname: {
            required,
          },
          message: {
            required,
          },
          amount: {
            required,
            between: between(this.minimumAmount, 10000000000000),
          },
        },
      };
    }
  },

  mounted() {
    if (
      this.$auth.user &&
      this.$auth.setting.gift_voucher &&
      this.$auth.setting.gift_voucher == "active"
    ) {
      this.minimumAmount = this.$auth.setting.minimum_voucher_amount;
      this.profile.fromname = this.$auth.user.user_name;
      this.getVoucherList();
    } else {
      this.$router.push({ name: "Home" });
    }
  },

  watch: {
    "profile.amount": function () {
      if (this.profile.amount < 1) {
        this.profile.amount = "";
      }
    },
  },

  methods: {
    ...mapActions("promocode", ["giftVoucherListData"]),
    ...mapMutations("order", [
      "chowmanPayGiftPlaceOrder",
      "clearPlaceOrderData",
      "chowmanPayPlaceOrder",
    ]),

    getVoucherList() {
      let data = { skip: 0, take: 100 };
      this.giftVoucherListData(data).then((response) => {
        if (response.code == 200) {
          this.voucherList = response.Result;
          if (response.Result.length > 0) {
            this.selectVoucher(response.Result[0]);
          }
        }
      });
    },

    selectVoucher(value) {
      this.selectGift = value;
    },

    send() {
      this.$v.$touch();
      if (this.$v.profile.$invalid) {
        return;
      } else {
        let chowmnGiftVoucher = {
          name: this.profile.toname,
          email: this.profile.toemail,
          custom_text: this.profile.message,
          amount: this.profile.amount,
          gift_voucher_id: this.selectGift.id,
          from_name: this.profile.fromname,
        };
        this.$store.commit("order/chowmanPayGiftPlaceOrder", chowmnGiftVoucher);
        this.$store.commit("order/chowmanPayPlaceOrder", {});
        this.$store.commit("order/clearPlaceOrderData");
        this.$router.push({ name: "payment" });
      }
    },
  },
};
</script>
<style scoped>
.gift-start .review-container {
  padding-top: 92px;
}

h4.gft-title {
  font-size: 25px;
  font-weight: bold;
}

.gift-start .myhome-slider .testimonial-item img {
  height: auto;
  object-fit: cover;
  width: 100%;
  border-radius: 10px;
}

.gift-full-img {
  position: relative;
  text-align: center;
}

.centered {
  color: black;
  font-weight: bold;
  font-size: 20px;
  margin-top: 12px;
  text-align: center;
}

.full-btn .send-cls {
  background: red !important;
  color: var(--theme-button-text-second-color) !important;
}

.gamnt .invalid-feedback {
  text-align: center;
}
</style>